<template>
  <div id="wrap-comments">

    <div id="header-drawer">
      <div id="title-drawer">
        <div id="title-drawer-icon">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn fab x-small depressed v-on="on"
                @click="$router.replace({ query: null })">
                <v-icon small>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </template>
            <span>리스트로 돌아가기</span>
          </v-tooltip>
        </div>
        <div>코멘트</div>
      </div>
    </div>

    <!-- Section write -->
    <div id="section-write">
      <v-divider></v-divider>
      <v-textarea solo flat
        rows=3
        color=#455ffe
        v-model="new_comment"
        placeholder="코멘트를 입력해주세요."
      ></v-textarea>
      <div id="section-write-actions">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="new_comment_private=!new_comment_private">
              <v-icon v-if="new_comment_private" color="#455ffe">mdi-lock</v-icon>
              <v-icon v-else>mdi-lock</v-icon>
            </v-btn>
          </template>
          <div>
            <div>비밀글로 설정하시면 작성자와 프로젝트 주인에게만 보입니다.</div>
            <div>비밀글 설정 후에는 일반글로 변경할 수 없습니다.</div>
          </div>
        </v-tooltip>
        <v-btn :disabled="!new_comment" @click="writeComment()"
          depressed small color="#455ffe" class="white--text" dense>보내기</v-btn>
      </div>

      <v-divider></v-divider>
    </div>

    <!-- section list -->
    <div id="comments-contents">
      <div>
        <v-card class="card-wrap" flat v-for="com in comment_list" :key="com.comment_id">
          <div class="card" v-if="!!com.comment||username==owner||com.created_by.username==username">
            <div class="card-header">
              <div class="card-header-left">
                <div class="card-title">
                  {{com.created_by.firstname}} {{com.created_by.lastname}}
                </div>
                <div v-if="com.created_by.username==username" 
                  class="card-chip-wrap me">
                  <div class="card-chip">Me</div>
                </div>
                <div v-else-if="com.created_by.username==owner" 
                  class="card-chip-wrap owner">
                  <div class="card-chip">Owner</div>
                </div>
                <div class="card-date">
                  {{com.created_ts}}
                </div>
                <div v-if="com.private">
                  <v-icon small>mdi-lock</v-icon>
                </div>
                <div v-if="com.status==1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on">mdi-eye-off</v-icon>
                    </template>
                    <div>
                      <div>Owner에 의해 숨겨진 글입니다.</div>
                      <div>Owner와 작성자 외 다른 사용자에게 보이지 않습니다.</div>
                    </div>
                  </v-tooltip>
                </div>
              </div>
              <div class="card-header-right" v-if="!editing&&!com.edit_mode">
                <div class="card-header-btn" 
                  v-if="com.created_by.username==username" 
                  @click="changeEditMode(true,com)">수정</div>
                <!-- <div>&nbsp;•&nbsp;</div> -->
                <div class="card-header-btn"
                  v-if="route_name=='project'&&com.created_by.username!=username&&com.status==0"
                  @click="changeStatus(com.comment_id, 1)">숨김</div>
                <div class="card-header-btn"
                  v-if="route_name=='project'&&com.created_by.username!=username&&com.status==1"
                  @click="changeStatus(com.comment_id, 0)">숨김해제</div>
                <div class="card-header-btn"
                  v-if="route_name=='project'||com.created_by.username==username"
                  @click="remove_dialog=true;remove_comment_id=com.comment_id">삭제</div>
              </div>
            </div>
            <!-- Read only -->
            <div class="card-comment" v-if="!com.edit_mode&&!!com.comment">
              {{ com.comment }}
            </div>
            <div class="card-comment card-comment-private" v-else-if="com.status==1">
              Owner에 의해 숨겨진 글입니다.
            </div>
            <div class="card-comment card-comment-private" v-else-if="!com.comment">
              비밀글입니다.
            </div>
            <!-- Editable -->
            <div class="card-comment" v-else>
              <v-textarea solo flat
                rows=3
                v-model="edit_comment">
              </v-textarea>
              <div id="section-write-actions">
                <v-tooltip bottom v-if="edit_comment_private">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="#455ffe">mdi-lock</v-icon>
                  </template>
                  <span>비밀글은 일반글로 변경할 수 없습니다.</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="new_edit_comment_private=!new_edit_comment_private">
                      <v-icon v-if="new_edit_comment_private" color="#455ffe">mdi-lock</v-icon>
                      <v-icon v-else>mdi-lock</v-icon>
                    </v-btn>
                  </template>
                  <div>
                    <div>비밀글로 설정하시면 작성자와 프로젝트 주인에게만 보입니다.</div>
                    <div>비밀글 설정 후에는 일반글로 변경할 수 없습니다.</div>
                  </div>
                </v-tooltip>
                <div>
                  <v-btn small text @click="changeEditMode(false,com)">
                    취소
                  </v-btn>
                  <v-btn @click="modifyComment(com)"
                    depressed small color="#455ffe" class="white--text" dense>수정</v-btn>
                </div>
              </div>
            </div>
          </div>

        </v-card>
      </div>
    </div>

    <!-- Remove Dialog -->
    <template>
      <v-dialog v-model="remove_dialog" width="300px">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span>코멘트를 삭제하시겠습니까?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small depressed
              @click="remove_dialog=false">
              아니오
            </v-btn>
            <v-btn small depressed color="primary"
              @click="deleteComment()">
              예, 삭제합니다.
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  
  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapGetters, mapMutations } from 'vuex'
import { coloring } from "../../../custom/fn_color"

export default {

  components: { VClamp },

  data(){
    return {
      comment_list: [],
      new_comment:'',
      new_comment_private: false,

      edit_comment:'',
      edit_comment_private: false,
      new_edit_comment_private: false,
      editing: false,

      remove_dialog: false,
      remove_comment_id: null,
    }
  },

  computed: {
    ...mapGetters({
      project_info: 'project/project_info',
      watching_project_info: 'watching/project_info',
      username: 'user/username',
      comments: 'comments/comments',
    }),

    route_name() {
      return this.$route.name
    },

    proj_id() {
      return parseInt(this.$route.params.id)
    },

    is_inactive() {
      return this.project_info.status >= 10
    },

    owner() {
      return this.route_name == 'project' ?
        this.username : this.watching_project_info.owner.name
    },
  },

  watch: {
    comments: {
      handler(val) {
        let comms = JSON.parse(JSON.stringify(val))
        comms.map(v => v.edit_mode = false)
        comms.sort((a,b) => (a.created_ts < b.created_ts) ? 1 : ((b.created_ts < a.created_ts) ? -1 : 0))
        this.comment_list = comms
      },
      deep: true,
    },
  },

  async created() {
    await this.getComments()
  },

  methods: {
    coloring,

    changeEditMode(status, comment) {
      if (status) {
        this.editing = true
        comment.edit_mode = true
        this.edit_comment = comment.comment
        this.edit_comment_private = comment.private
        this.new_edit_comment_private = comment.private
      } else {
        this.editing = false
        comment.edit_mode = false
      }
    },

    async writeComment(){
      try {
        if (!!this.new_comment) {
          this.$store.dispatch('comments/writeComment', {
            'proj_id': this.proj_id,
            'comment': this.new_comment,
            'private': this.new_comment_private
          })
        }
      } finally {
        this.new_comment = ""
        this.new_comment_private = false
      }
    },

    async modifyComment(comment){
      try {
        this.$store.dispatch('comments/modifyComment', {
          'proj_id': this.proj_id,
          'comment_id': comment.comment_id,
          'comment': this.edit_comment,
          'private': this.new_edit_comment_private,
        })
      } finally {
        comment.edit_mode = false
        this.editing = false
      }
    },

    async changeStatus(comment_id, status) {
      this.$store.dispatch('comments/changeStatus', {
        'proj_id': this.proj_id,
        'comment_id': comment_id,
        'status': status,
      })
    },
    
    async deleteComment(comment_id){
      try {
        this.$store.dispatch('comments/deleteComment',{
          'proj_id': this.proj_id,
          'comment_id': this.remove_comment_id,
        })
      } finally {
        this.remove_dialog = false
      }
    },

    async getComments(){
      this.$store.dispatch('comments/getComments', this.proj_id)
    },

  }

}

</script>

<style scoped>

  #header-drawer {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
    font-size: 16px;
    font-weight: 600;
  }

  #title-drawer {
    width: 140px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #title-drawer-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #title-drawer-icon button{
    margin-right: 8px;
  }

  #section-write-actions {
    padding: 0 12px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  #comments-contents {
    overflow-y: auto;
    padding: 12px;
  }

  .card-wrap {
    width: 100%;
  }

  .card {
    padding: 8px 12px;
    margin-bottom: 12px;
    border-radius: 4px;
    border: solid 1px #dde2e5 !important;
    background-color: #ffffff;
  }

  .card-wrap:hover {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  }

  .card-header, .card-header>div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .card-header {
    justify-content: space-between;
  }

  .card-header-btn {
    color: #455ffe;
    cursor: pointer;
    margin-left: 3px;
  }

  .card-title {
    font-size: 14px;
    font-weight: 600;
    color: #323334;
    margin-right: 4px;
  }

  .card-chip-wrap {
    margin-right: 8px;
    background-color: rgba(83, 107, 255, 0.1);
    padding: 1px 2px;
  }

  .card-chip {
    font-size: 8px;
    font-weight: 500;
  }

  .owner {
    background-color: rgba(255, 81, 147, 0.1);
    color: #ff5193;
  }

  .me {
    background-color: rgba(83, 107, 255, 0.1);
    color: #455ffe;
  }

  .card-date {
    color: #858d97;
    margin-right: 8px;
  }

  .card-comment {
    margin-top: 8px;
  }

  .card-comment-private {
    color: #858d97;
  }

  .card-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

</style>


// WEBPACK FOOTER //
// src/components/shared_components/whole/Comments.vue